import * as yup from 'yup'

import helpers from 'helpers'

export const schemaData = yup.object().shape({
  name: yup.string().when('kind', {
    is: helpers.people.isPerson,
    then: yup.string().required(),
  }),
  email: yup
    .string()
    .email()
    .emailAvailable()
    .required(),
  cpf: yup
    .string()
    .cpf()
    .cpfAvailable({ kindRef: yup.ref('kind') })
    .required()
    .when('kind', {
      is: helpers.people.isCompany,
      then: yup
        .string()
        .cpf()
        .cpfAvailable({ kindRef: yup.ref('kind') }),
    }),
  phone: yup
    .string()
    .min(14)
    .max(15),
  kind: yup.string().required(),

  cnpj: yup.string().when('kind', {
    is: helpers.people.isCompany,
    then: yup
      .string()
      .cnpj()
      .cnpjAvailable()
      .required(),
  }),
  tradeName: yup.string().when('kind', {
    is: helpers.people.isCompany,
    then: yup.string(),
  }),
  companyName: yup.string().when('kind', {
    is: helpers.people.isCompany,
    then: yup.string().required(),
  }),
})

export default schemaData
